"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLayout = exports.PageLayoutState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const banner_1 = require("../components/banner/banner");
const license_banner_1 = require("../components/license.banner/license.banner");
const message_banner_1 = require("../components/message.banner/message.banner");
const modal_service_1 = require("../components/modal/modal.service");
const notification_service_1 = require("../components/notification.toast/notification.service");
const theme_1 = require("../components/theme");
const mithril_1 = require("../mithril");
const nav_drawer_1 = require("../modules/nav.drawer/nav.drawer");
const nav_drawer_ctrl_1 = require("../modules/nav.drawer/nav.drawer.ctrl");
const CSS = {
    container: 'c-Page',
    banner: 'c-Page__Banner',
    content: 'c-Page__Content',
    layout: 'c-Page__Layout',
    overlay: 'c-Page__Overlay',
    constrainWidth: 'c-Page__ConstrainWidth',
};
const Style = {
    [CSS.container]: {
        'background-color': theme_1.DefaultTheme.background.offWhite,
        'font-size': theme_1.DefaultTheme.font.size,
        color: theme_1.DefaultTheme.font.color.primary,
        'font-family': theme_1.DefaultTheme.font.family,
    },
    [CSS.content]: {
        flex: 1,
    },
    'mdl-layout--fixed-drawer > .mdl-layout__content': {
        padding: theme_1.DefaultTheme.space(4),
    },
    // Unrestrict height for printing across multiple pages
    '@media print': {
        [CSS.layout]: {
            height: 'auto',
            display: 'block',
        },
        [CSS.content]: {
            display: 'block',
        },
    },
};
(0, theme_1.addStyles)(Style);
exports.PageLayoutState = {
    nav: new nav_drawer_ctrl_1.NavDrawerCtrl(),
};
class PageLayout {
    constructor() {
        if (PageLayout.banner == null) {
            PageLayout.banner = new banner_1.BannerComponent();
        }
        this.messageBanner = new message_banner_1.MessageBannerComponent();
        this.licenseBanner = new license_banner_1.LicenseBannerComponent();
    }
    setPage(page) {
        this.page = page;
    }
    view() {
        if (this.page == null) {
            return null;
        }
        const config = this.page.config;
        return (0, mithril_1.m)('div', { className: `${CSS.container} mdl-layout__container` }, [
            (0, mithril_1.m)('div', { className: `${CSS.layout} mdl-layout ${config.layout.nav ? 'mdl-layout--fixed-drawer' : ''}` }, [
                this.messageBanner.view(),
                this.licenseBanner.view(),
                // Banner (top)
                config.layout.banner ? (0, mithril_1.m)('div', { className: CSS.banner }, PageLayout.banner.view()) : null,
                // Nav Drawer (left)
                nav_drawer_1.NavDrawer.view(exports.PageLayoutState.nav),
                // Content (center)
                (0, mithril_1.m)('div', { className: `${CSS.content} mdl-layout__content` }, this.page.view()),
                // Overlays (display over all other elements)
                (0, mithril_1.m)('div', { className: CSS.overlay }, [modal_service_1.ModalService.view(), notification_service_1.NotificationService.view()]),
            ]),
        ]);
    }
}
exports.PageLayout = PageLayout;
tslib_1.__decorate([
    mobx_1.observable.ref
], PageLayout.prototype, "page", void 0);
tslib_1.__decorate([
    mobx_1.action
], PageLayout.prototype, "setPage", null);
//# sourceMappingURL=page.layout.js.map